import { useCallback, useMemo, useState } from 'react';

export interface PaginationModel {
  pageSize: number;
  currentPage: number;
  changeCurrentPage: (page: number) => Promise<void>;
  changePageSize: (size: number, page?: number) => Promise<void>;
}

export const usePagination = (defaultPageSize: number, defaultPage: number): PaginationModel => {
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);
  const [currentPage, setCurrentPage] = useState<number>(defaultPage);

  const changePageSize = useCallback(async (size: number, page?: number) => {
    setCurrentPage(page ?? 1);
    setPageSize(size);
  }, []);

  const changeCurrentPage = useCallback(async (page: number) => {
    setCurrentPage(page);
  }, []);

  return useMemo(() => ({
    pageSize,
    currentPage,
    changeCurrentPage,
    changePageSize,
  }), [changeCurrentPage, changePageSize, currentPage, pageSize]);
};
